var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcBulb = function SvgIcBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_bulb_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.332 7.816c-.14-3.858-3.304-6.978-7.164-7.064A7.336 7.336 0 0 0 3.52 11.527l-.003-.002.023.041c.02.038.043.075.064.113a7.91 7.91 0 0 0 .24.396l.083.127c1.039 1.547 1.922 1.658 2.235 2.839h3.175V11.51L7.644 9.815a.701.701 0 1 1 .992-.992L10.01 10.2l1.354-1.354a.701.701 0 1 1 .992.992l-1.695 1.695v3.508h3.175c.314-1.185 1.203-1.292 2.246-2.853l.003-.003a7.7 7.7 0 0 0 .227-.361c.057-.096.114-.194.17-.299l-.004.003c.586-1.1.9-2.367.852-3.711Z",
    fill: "#FFC33A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.662 15.042v-3.509l1.695-1.694a.701.701 0 1 0-.992-.992L10.011 10.2 8.636 8.825a.701.701 0 1 0-.992.992l1.694 1.694v3.531h1.325Z",
    fill: "#FF9000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.177 15.041c.003.08.006.162.007.248v1.439c0 1.392 1.229 2.521 2.622 2.521h2.388c1.392 0 2.637-1.128 2.637-2.521v-1.384c0-.107.003-.207.007-.303H6.177Z",
    fill: "#7D8996"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.924 15.154H6.092v1.5h7.832v-1.5Z",
    fill: "#4B596A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_bulb_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIcBulb;